import React from "react";
import { ScrollingProvider } from "../../context/ScrollingContext";
import SectionHead from "../../components/ui/SectionHead";

import auth from "../../services/authServices";

import YearsSection from "./YearsSection";

import { ReactComponent as UnderLine } from "../../assets/Updated-imagery/underlineArabic.svg";

const Services = ({ title = false }) => {
    const token = auth.getToken();

    return (
        <section className="space-y-10 py-14 relative">
            <div className="px-5 md:px-20 flex gap-10 sm:gap-20 flex-col items-center">
                <div className="w-full relative lg:max-w-[1280px] space-y-1 flex-center-both">
                    <div className="flex-center-both flex-col space-y-2 text-center relative ">
                        <h1 className="font-ibm flex-center-both space-x-3 space-x-reverse font-semibold text-cocoaBrown-500 text-4xl md:text-5xl mb-8">
                            <div className="w-2 h-14 bg-tomato-500" />
                            <span>جميع السنوات الدراسية </span>
                            <div className="w-2 h-14 bg-tomato-500" />
                        </h1>
                        <div className="flex justify-center mt-1">
                            <UnderLine className="w-1/2" />
                        </div>
                    </div>
                </div>
                <div className="flex flex-center-both">
                    <YearsSection layout="InteractiveGlassCard" />
                </div>
            </div>
        </section>
    );
};

export default Services;
